import { render, staticRenderFns } from "./stripedView.vue?vue&type=template&id=48a62ab5&scoped=true&"
import script from "./stripedView.vue?vue&type=script&lang=js&"
export * from "./stripedView.vue?vue&type=script&lang=js&"
import style0 from "./stripedView.vue?vue&type=style&index=0&id=48a62ab5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a62ab5",
  null
  
)

export default component.exports